import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, List, Button, Modal, InputItem, Toast, Badge, ActionSheet, Flex } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import { createForm } from 'rc-form';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import StorageUtils from '../utils/StorageUtils';
import iconOnline from '../medias/online.svg';
import iconOffline from '../medias/offline.svg';
import iconBusy from '../medias/busy.svg';
import iconIdle from '../medias/idle.svg';
import '../styles/DevicePage.css';

const history = require("history").createHashHistory()
const alert = Modal.alert

class DevicePage extends Component {
    static defaultProps = {
        fetchSites: (params, callback) => {},
        fetchDevices: (params, callback) => {},
        fetchStatistic: (params, callback) => {},
        fetchDeviceTypes: (params, callback) => {},
        updateDevice: (params, callback, completed) => {},
        logoutDevice: (params, callback) => {},
        restartDevice: (params, callback) => {},
        alertDevice: (params, callback, completed) => {},
        sendGift: (params, callback, completed) => {},
        deviceLogLink: (record) => {},
        delegateProfile: (params, callback) => {}
    }

    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            showUpdateModal: false,
            enableUpdate: true,
            showAlertModal: false,
            enableAlert: true,
            showGiftModal: false,
            enableGift: true,
            selectedItem: null,
            sites: [],
            deviceStatistic: {
                onlineCount: 0,
                offlineCount: 0,
                busyCount: 0,
                idleCount: 0
            },
            selectedSite: '',
            statusFilter: {
                idle: '',
                online: ''
            },
            deviceType: '',
            delegateProfile: null,
            deviceTypes: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 190;
        this.setState({
            height
        })

        this.props.delegateProfile({}, (resp) => {
            this.setState({
                delegateProfile: resp.data
            })
        })

        this.loadPageData(1)
        this.loadDeviceStatistic()
        this.loadSites()
        this.loadDeviceTypes()
    }

    loadPageData = (pageNum) => {
        const { selectedSite, statusFilter, deviceType } = this.state
        const params = {
            pageNum,
            pageSize: 10,
            siteId: selectedSite,
            online: statusFilter.online,
            idle: statusFilter.idle,
            deviceType
        }

        this.props.fetchDevices(params, (resp) => {
            let data = resp.data
            this.pageNum = data.pageNum;
            this.pageSize = data.pageSize;
            this.pages = data.pages;
            let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
            this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                isLoading: false,
                hasMore: this.pageNum < this.pages,
            })
        })
    }

    loadSites = () => {
        this.props.fetchSites({}, (resp) => {
            this.setState({
                sites: resp.data
            })
        })
    }

    loadDeviceTypes = () => {
        this.props.fetchDeviceTypes({}, (resp) => {
            this.setState({
                deviceTypes: resp.data
            })
        })
    }

    loadDeviceStatistic = () => {
        const { selectedSite, deviceType } = this.state
        const params = {
            siteId: selectedSite,
            deviceType
        }
        this.props.fetchStatistic(params, (resp) => {
            this.setState({
                deviceStatistic: resp.data
            })
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onSitePickerChange = (val) => {
        this.setState({
            selectedSite: val[0]
        }, () => {
            this.loadPageData(1)
            this.loadDeviceStatistic()
        })
    }

    onDeviceTypePickerChange = (val) => {
        this.setState({
            deviceType: val[0]
        }, () => {
            this.loadPageData(1)
            this.loadDeviceStatistic()
        })
    }

    handleFilterStatusClick = (type, value) => {
        const { statusFilter } = this.state

        if(type === 'online') {
            if(statusFilter.online === value) {
                statusFilter.online = ''
            } else {
                statusFilter.online = value
            }
        } else if(type === 'idle') {
            if(statusFilter.idle === value) {
                statusFilter.idle = ''
            } else {
                statusFilter.idle = value
            }
        }
        this.setState({
            statusFilter
        }, () => {
            this.loadPageData(1)
        })
    }

    handleItemClick = (rowData) => {
        const { delegateProfile } = this.state

        const options = []
        if(!delegateProfile || delegateProfile.delegateType === 'OPERATOR') {
            options.push({ icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' })
            if(rowData.playUserId) {
                options.push({ icon: <i className='iconfont icon-dengchu' style={{color:'orange', fontSize: 30}}/>, title: '登出设备' })
                options.push({ icon: <i className='iconfont icon-youxiyouxiji' style={{color:'green', fontSize: 30}}/>, title: '赠送时间' }) 
            } else {
                options.push({ icon: <i className='iconfont icon-guize' style={{color:'green', fontSize: 40}}/>, title: '消息推送' })
            }
            options.push({ icon: <i className='iconfont icon-ziyuanxhdpi' style={{color:'orangered', fontSize: 30}}/>, title: '重启设备' })
        }
        options.push({ icon: <i className='iconfont icon-rizhi1' style={{color:'#1296db', fontSize: 30}}/>, title: '设备日志' })
        if(!options.length) {
            Toast.info('无操作权限')
            return
        }
        
        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }

        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.deviceName?rowData.deviceName:rowData.deviceId,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '登出设备') {
                this.handleLogoutClick(rowData)
            } else if(buttonTitle === '重启设备') {
                this.handleRestartClick(rowData)
            } else if(buttonTitle === '设备日志') {
                history.push(this.props.deviceLogLink(rowData))
            } else if(buttonTitle === '消息推送') {
                this.setState({
                    showAlertModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '赠送时间') {
                this.setState({
                    showGiftModal: true,
                    selectedItem: rowData
                })
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('update_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('update_'.length)] = propValue
            }

            this.props.updateDevice(params, (resp) => {
                this.setState({
                    showUpdateModal: false
                })
                this.props.form.resetFields()
                this.loadPageData(1)
            }, () => {
                this.setState({
                    enableUpdate: true
                })
            })
        });
    }

    handleLogoutClick = (rowData) => {
        if(!rowData) return

        let deviceName = rowData.deviceName ? rowData.deviceName : rowData.deviceId
        alert('确认要登出设备?', deviceName, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                this.props.logoutDevice({
                    deviceId: rowData.deviceId
                }, (resp) => {
                    Toast.info('正在登出该设备', 5)
                    this.loadPageData(1)
                    this.loadDeviceStatistic()
                })
            }},
          ])
    }

    handleRestartClick = (rowData) => {
        if(!rowData) return

        let deviceName = rowData.deviceName ? rowData.deviceName : rowData.deviceId
        alert('确认要重启设备?', deviceName, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                this.props.restartDevice({
                    deviceId: rowData.deviceId
                }, (resp) => {
                    Toast.info('正在重启该设备', 5)
                    this.loadPageData(1)
                    this.loadDeviceStatistic()
                })
            }},
        ])
    }

    handleAlertClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableAlert: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('alert_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableAlert: true
                        })
                        return
                    }
                }
            }

            if(CommonUtils.isNotEmpty(fieldsValue.alert_content)) {
                StorageUtils.storeStringToLocal(Constants.Storage.DEVICE_ALERT_MSG, fieldsValue.alert_content)
            }

            const params = {
                deviceId: selectedItem.deviceId
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('alert_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('alert_'.length)] = propValue
            }

            this.props.alertDevice(params, (resp) => {
                this.setState({
                    showAlertModal: false
                })
                this.props.form.resetFields()
                Toast.info('消息已推送', 3)
            }, () => {
                this.setState({
                    enableAlert: true
                })
            })
        });
    }

    handleGiftClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableGift: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('gift_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableGift: true
                        })
                        return
                    }
                }
            }

            const params = {
                userId: selectedItem.playUserId,
                siteId: selectedItem.siteId,
                deviceType: selectedItem.deviceType
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('gift_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('gift_'.length)] = propValue
            }

            this.props.sendGift(params, (resp) => {
                this.setState({
                    showGiftModal: false
                })
                this.props.form.resetFields()
                Toast.info('时间已送出')
                this.loadPageData(1)
                this.loadDeviceStatistic()
            }, () => {
                this.setState({
                    enableGift: true
                })
            })
        })
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    generatePlayUserInfo = (rowData) => {
        if(!rowData.playUserId) return

        return (
            <div className='info-play-user'>
                <div><img src={rowData.playUserAvatar} alt=""/></div>
                <div className='nickname word-ellipsis'>{rowData.playUserNickName}</div>
                {this.doGeneratePlayerTag(rowData)}
                <div className='tag'><Badge text={CommonUtils.readableGameMinutes(rowData.playUserGameMinutes)} style={{backgroundColor: 'orange'}}/></div>
                {rowData.virtualPlayer?<div></div>:<div className='tag'><Badge text={`￥${rowData.playUserBalance?rowData.playUserBalance:0}`} style={{backgroundColor: 'orange'}}/></div>}
            </div>
        )
    }

    doGeneratePlayerTag = (rowData) => {
        if(rowData.virtualPlayer) {
            return <div className='tag'><Badge text="小号" style={{backgroundColor: 'orange'}}/></div>
        }

        if(!rowData.playUserNew) {
            return <div className='tag'><Badge text="复购" style={{backgroundColor: 'orange'}}/></div>
        }
    }

    resolveJoinDaysInfo = (rowData) => {
        if(!rowData.playUserId) {
            return '无'
        }

        return CommonUtils.resolveJoinDaysInfo(rowData.playUserJoinDays)
    }

    renderRow = (rowData, sectionId, rowId) => {
        let onlineBadge = (
            <Badge text={rowData.online&&rowData.online===1?'在线':'离线'} 
                   style={{backgroundColor: `${rowData.online&&rowData.online===1?'#04bbc5':'gray'}`}}/>)

        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.deviceName?rowData.deviceName:rowData.deviceId}</span>}
                            extra={onlineBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>门&nbsp;&nbsp;&nbsp;店：</span> 
                                    <span>{rowData.siteName}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>版&nbsp;&nbsp;&nbsp;本：</span> 
                                    <span>v{rowData.appVersion}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>状&nbsp;&nbsp;&nbsp;态：</span> 
                                    <span>{rowData.playUserId?'登录':'空闲'}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>设备ID：</span> 
                                    <span>{rowData.deviceId}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>注&nbsp;&nbsp;&nbsp;册：</span> 
                                    <span>{this.resolveJoinDaysInfo(rowData)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>登&nbsp;&nbsp;&nbsp;录：</span> 
                                    <span>{rowData.playStartTime?rowData.playStartTime:'无'}</span>
                                </div>
                            </div>
                            {this.generatePlayUserInfo(rowData)}
                        </Card.Body>
                        <Card.Footer content={<span>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>} extra={<span>{rowData.lastOnlineTime?`【连接】${rowData.lastOnlineTime}`:''}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderGiftModal = () => {
        const { getFieldProps } = this.props.form;
        const { showGiftModal, enableGift, selectedItem } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showGiftModal}
                    onClose={() => {
                        this.setState({showGiftModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>赠送时间</div>}>
                        <InputItem disabled {...getFieldProps('gift_userNickName', {
                            initialValue: selectedItem?selectedItem.playUserNickName:null,
                        })}>
                            用户
                        </InputItem>
                        <InputItem disabled {...getFieldProps('gift_deviceTypeName', {
                            initialValue: selectedItem?CommonUtils.resolveDictText(selectedItem.deviceType, this.state.deviceTypes, 'code', 'name'):null,
                        })}>
                            类型
                        </InputItem>
                        <InputItem type='number' extra="分钟" {...getFieldProps('gift_gameMinutes', {
                            initialValue: selectedItem&&selectedItem.playUserGameMinutes?selectedItem.playUserGameMinutes:15,
                            rules: [{required: true, message: '请填写时间'}],
                        })}>
                            时间
                        </InputItem>
                        <InputItem {...getFieldProps('gift_remark', {
                            initialValue: selectedItem?`设备${selectedItem.deviceName}`:null,
                        })}>
                            备注
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleGiftClick} disabled={!enableGift}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderAlertModal = () => {
        const { getFieldProps } = this.props.form;
        const { showAlertModal, enableAlert, selectedItem } = this.state
        let alertMsg = StorageUtils.retrieveStringFromLocal(Constants.Storage.DEVICE_ALERT_MSG)
        if(CommonUtils.isEmpty(alertMsg)) {
            alertMsg = Constants.Strings.DEFAULT_DEVICE_ALERT_MSG
        }
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showAlertModal}
                    onClose={() => {
                        this.setState({showAlertModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>消息推送</div>}>
                        <InputItem disabled {...getFieldProps('alert_deviceName', {
                            initialValue: selectedItem?selectedItem.deviceName:null,
                        })}>
                            设备
                        </InputItem>
                        <InputItem {...getFieldProps('alert_content', {
                            initialValue: alertMsg,
                            rules: [],
                        })}>
                            内容
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleAlertClick} disabled={!enableAlert}>推送</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, selectedItem, sites } = this.state
        const sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <InputItem disabled {...getFieldProps('update_deviceTypeName', {
                            initialValue: selectedItem?CommonUtils.resolveDictText(selectedItem.deviceType, this.state.deviceTypes, 'code', 'name'):null,
                        })}>
                            类&nbsp;&nbsp;&nbsp;&nbsp;型
                        </InputItem>
                        <InputItem disabled {...getFieldProps('update_deviceId', {
                            initialValue: selectedItem?selectedItem.deviceId:null,
                        })}>
                            设备ID
                        </InputItem>
                        <InputItem {...getFieldProps('update_deviceName', {
                            initialValue: selectedItem?selectedItem.deviceName:null,
                            rules: [{required: true, message: '请填写设备名'}],
                        })}>
                            设备名
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={sitePickerData}
                            {...getFieldProps('update_siteId', {
                                initialValue: selectedItem?[selectedItem.siteId]:[],
                                rules: [{required: true, message: '请选择门店'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">门&nbsp;&nbsp;&nbsp;&nbsp;店</List.Item>
                        </Picker>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { sites, selectedSite, statusFilter, deviceStatistic, deviceType, deviceTypes } = this.state;
        const sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedSite]}
                        onOk={this.onSitePickerChange}
                        data={[{value:'', label:'所有门店'}, ...sitePickerData]}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 筛选</span>
                        </List.Item>
                    </Picker>
                </WingBlank>
                <WhiteSpace size='sm'/>
                <WingBlank size="md">
                    <Flex className='filter-status'>
                        <Flex.Item onClick={() => {this.handleFilterStatusClick('online', '1')}} className={`${statusFilter.online==='1'?'selected':''}`}>
                            <img src={iconOnline} alt="在线"/>
                            <div className='label word-ellipsis'><i className='iconfont icon-wancheng1'/> 在线 {deviceStatistic.onlineCount}</div>
                        </Flex.Item>
                        <Flex.Item onClick={() => {this.handleFilterStatusClick('online', '0')}} className={`${statusFilter.online==='0'?'selected':''}`}>
                            <img src={iconOffline} alt="离线"/>
                            <div className='label word-ellipsis'><i className='iconfont icon-wancheng1'/> 离线 {deviceStatistic.offlineCount}</div> 
                        </Flex.Item>
                        <Flex.Item onClick={() => {this.handleFilterStatusClick('idle', 'false')}} className={`${statusFilter.idle==='false'?'selected':''}`}>
                            <img src={iconBusy} alt="登录"/>
                            <div className='label word-ellipsis'><i className='iconfont icon-wancheng1'/> 登录 {deviceStatistic.busyCount}</div> 
                        </Flex.Item>
                        <Flex.Item onClick={() => {this.handleFilterStatusClick('idle', 'true')}} className={`${statusFilter.idle==='true'?'selected':''}`}>
                            <img src={iconIdle} alt="空闲"/>
                            <div className='label word-ellipsis'><i className='iconfont icon-wancheng1'/> 空闲 {deviceStatistic.idleCount}</div> 
                        </Flex.Item>
                    </Flex>
                </WingBlank>
                <div className='device-type-picker'>
                    <Picker
                        cols={1}
                        value={[deviceType?deviceType:'']}
                        onOk={this.onDeviceTypePickerChange}
                        data={[{label:'所有设备', value: ''}, ...deviceTypePickerData]}>
                        <List.Item></List.Item>
                    </Picker>
                </div>
            </div>
        )
    }

    render() {
        const { dataSource, isLoading } = this.state;

        return (
            <div className='device-page'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                >
                    设备管理
                </NavBar>
                {this.doRenderFilterView()}
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 182
                    }}
                />
                {this.doRenderUpdateModal()}
                {this.doRenderAlertModal()}
                {this.doRenderGiftModal()}
            </div>
        )
    }
}

export default createForm()(DevicePage);


// WEBPACK FOOTER //
// ./src/components/DevicePage.js